import React, { FC } from 'react';
import { createPortal } from 'react-dom';
import SystemMessagesComponent from './SystemMessagesComponent';

interface Props {
  systemId : number;
}

const SystemMessagesWrapperComponent: FC<Props> = ({ systemId }) => {
  const container = document.querySelector('.app-systemmessages-container');

  if (container) {
    return (
      <>
        {createPortal(
          <SystemMessagesComponent systemId={systemId} />,
          container,
        )}
      </>
    );
  }
  return null;
};

SystemMessagesWrapperComponent.displayName = 'SystemMessagesWrapperComponent';
export default SystemMessagesWrapperComponent;
